module.exports = __webpack_public_path__ + "static/photo1-1037cc6a89d0aa02e488c94df2a3c32e.jpg";